/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useIntersectionObserver } from 'usehooks-ts';

import AyasListItemMenuBtn from '../menu-btn';
import { Ayat } from '@/infrastructure/class/ayat';
import { ReadSurah } from '@/infrastructure/class/read-surah';
import { AudioSurah } from '@/infrastructure/class/audio-surah';
import s from './styles.module.scss';

interface IAyasListItemProps {
  data: Ayat;
  surah: AudioSurah | ReadSurah;
  needTopBorder?: boolean;
  isArabicTranslation: boolean;
  onView?: (ayat: Ayat) => void;
}

export const ayatId = (ayatNumber: number) => `ayat-${ayatNumber}`;

const AyasListItem: React.FC<IAyasListItemProps> = (props) => {
  const { data, surah, isArabicTranslation, onView = () => {} } = props;

  const ref = useRef<HTMLLIElement | null>(null);

  const arabicTextClassNames = classNames(s['text']);
  const translationClassNames = classNames(s['translate'], {
    [s['ar']]: isArabicTranslation,
  });

  const entry = useIntersectionObserver(ref, {
    threshold: 0.5,
    freezeOnceVisible: true,
  });

  useEffect(() => {
    if (!!entry?.isIntersecting) {
      onView(data);
    }
  }, [entry]);

  return (
    <li ref={ref} id={ayatId(data.number)} className={s['list-item']}>
      <p className={s['number']}>
        <span>{data.number}</span>
      </p>
      <p className={arabicTextClassNames}>{data.text}</p>
      {data.translate && (
        <p className={translationClassNames}>{data.translate}</p>
      )}
      <AyasListItemMenuBtn
        className={s['menu-btn']}
        data={data}
        surah={surah}
      />
    </li>
  );
};

export default AyasListItem;
